import { render, staticRenderFns } from "./DeviceAttributes.vue?vue&type=template&id=15d64d49"
import script from "./DeviceAttributes.vue?vue&type=script&lang=js"
export * from "./DeviceAttributes.vue?vue&type=script&lang=js"
import style0 from "./DeviceAttributes.vue?vue&type=style&index=0&id=15d64d49&prod&lang=scss"
import style1 from "./DeviceAttributes.vue?vue&type=style&index=1&id=15d64d49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports